enum EnumUserGender {
    Male = "Male",
    Female = "Female",
    Other = "Other"
}

export default EnumUserGender
